import { Injectable } from '@angular/core';
import { Headers, Request, Response, RequestMethod, RequestOptionsArgs, RequestOptions } from '@angular/http';
import { environment } from '../../../environments/environment';
import { HttpHelper } from '../../common/helpers/http.helper';
import { String } from '../../common/helpers/string.helper';
import { IPayout } from '../models/my-company/payout.dc.model';
import { IPlan } from '../models/my-company/plan.dc.model';
import { IAltGoals } from '../models/my-company/alt-goals.model';
import { IImpInfo } from '../models/my-company/important-info.model';
import { Observable } from 'rxjs';
import { ApprovalType } from '../models/my-company/approval-type.model';
import { of } from 'rxjs/observable/of';
import { SessionHelper } from '../../common/helpers/session.helper';

@Injectable()
export class ConfigurationService {

    constructor(private _httpHelper: HttpHelper) {
    }

    // Affiliate Type

    public getAffiliateTypeList() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "affiliate/typemaster/details"
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getAffiliateTypeById(id: string) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "affiliatetype/details/" + id;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdateAffiliateType(addAffiliateType: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "affiliate/typemaster/addupdate"
        return this._httpHelper.post(environment.APIBaseUrl + url, addAffiliateType, reqOption);

    }

    public deleteAffiliateTypeById(affiliateType: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "affiliate/typemaster/delete/" + affiliateType;
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }

    // Temperature

    public getTemperatureList() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "affiliate/temperature/details"
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getTemperatureById(id: string) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "affiliate/temperature/details/" + id;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdateTemperature(addTemperatureAgreement: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "affiliate/temperature/addupdate"
        return this._httpHelper.post(environment.APIBaseUrl + url, addTemperatureAgreement, reqOption);
    }
    public deleteTemperatureById(TemperatureAgreementId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "affiliate/temperature/delete/" + TemperatureAgreementId
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }


    // Billing InvoiceCharged


    public getBillingInvoiceChargedList() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "billing/invoicecharged/details"
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getBillingInvoiceChargedById(id: string) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "billing/invoicecharged/details" + id;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdateBillingInvoiceCharged(addInvoiceCharged: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "billing/invoicecharged/addupdate"
        return this._httpHelper.post(environment.APIBaseUrl + url, addInvoiceCharged, reqOption);
    }
    public deleteBillingInvoiceChargedById(InvoiceChargedId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "billing/invoicecharged/delete/" + InvoiceChargedId
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }


    //Billing Discount


    public getBillingDiscountDetail() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "billing/discount/details"
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getBillingDiscountById(id: string) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "billing/discount/details" + id;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdateBillingDiscount(addDiscount: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "billing/discount/addupdate"
        return this._httpHelper.post(environment.APIBaseUrl + url, addDiscount, reqOption);
    }
    public deleteBillingDiscountById(DiscountId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "billing/discount/delete/" + DiscountId
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }


    // Billing PaymentStatus


    public getBillingPaymentStatusDetail() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "billing/paymentstatus/details"
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getBillingPaymentStatusById(id: string) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "billing/paymentstatus/details" + id;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdateBillingPaymentStatus(addPaymentStatus: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "billing/paymentstatus/addupdate"
        return this._httpHelper.post(environment.APIBaseUrl + url, addPaymentStatus, reqOption);
    }
    public deleteBillingPaymentStatusById(PaymentStatusId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "billing/paymentstatus/delete/" + PaymentStatusId
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }


    //Contacts ContactType


    public getContactTypeDetail() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contactMaster/contacttype/details"
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }


    //// Contacts RoundMaster////

    public getContactsRoundMasterDetailWithInactiveRecords() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contactMaster/roundmaster/detailswithinactiverecords"
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getContactsRoundMasterDetail() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contactMaster/roundmaster/details"
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getContactsRoundMasterById(id: string) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({
            method: RequestMethod.Get,
            headers: headers,
        });
        let url = "contactMaster/roundmaster/details/" + id;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdateContactsRoundMaster(addRoundMaster: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "contactMaster/roundmaster/addupdate"
        return this._httpHelper.post(environment.APIBaseUrl + url, addRoundMaster, reqOption);
    }
    public deleteContactsRoundMasterById(RoundMasterId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "contactMaster/roundmaster/delete/" + RoundMasterId
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }


    //// Contacts Status////


    public getContactsStatusDetailWithInactiveData() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contactMaster/contactstatus/detailswithinactivedata";
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getContactsStatusDetail() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contactMaster/contactstatus/details"
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getContactsStatusById(id: string) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contactMaster/contactstatus/details" + id;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdateContactsStatus(addStatus: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "contactMaster/contactstatus/addupdate"
        return this._httpHelper.post(environment.APIBaseUrl + url, addStatus, reqOption);
    }
    public deleteContactsStatusById(StatusId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "contactMaster/contactstatus/delete/" + StatusId
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }


    ////Contacts BillingStatus/////


    public getContactsBillingStatusDetail() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contactMaster/billingstatus/details"
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getContactsBillingStatusById(id: string) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contactMaster/billingstatus/details/" + id;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdateContactsBillingStatus(addBillingStatus: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "contactMaster/billingstatus/addupdate"
        return this._httpHelper.post(environment.APIBaseUrl + url, addBillingStatus, reqOption);
    }
    public deleteContactsBillingStatusById(BillingStatusId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "contactMaster/billingstatus/delete/" + BillingStatusId
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }


    //// Contacts CRGoal ////
    public getContactsCRGoalDetail() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contactMaster/crgoal/details"
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }
    public getAllCRGoalDetail() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contactMaster/crgoal/details"
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }


    public getContactsCRGoalById(id: string) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contactMaster/crgoal/details/" + id;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdateContactsCRGoal(addCRGoal: any) {
        let file: FormData = addCRGoal.Image;
        addCRGoal.Image = "";
        let headers: Headers = new Headers();
        headers.append('RequestModel', JSON.stringify(addCRGoal));
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "contactMaster/crgoal/addupdate"
        return this._httpHelper.postFile(environment.APIBaseUrl + url, file, reqOption);
    }
    public deleteContactsCRGoalById(CRGoalId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "contactMaster/crgoal/delete/" + CRGoalId
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }

    public getCRGoalByContactId(contactid: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contactMaster/crgoal/activedetails/" + contactid;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    /////// Contacts EstimatedTimeline ////////


    public getContactsEstimatedTimelineDetail() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contactMaster/estimatedtimeline/details"
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getContactsEstimatedTimelineById(id: string) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contactMaster/estimatedtimeline/details/" + id;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdateContactsEstimatedTimeline(addEstimatedTimeline: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "contactMaster/estimatedtimeline/addupdate"
        return this._httpHelper.post(environment.APIBaseUrl + url, addEstimatedTimeline, reqOption);
    }
    public deleteContactsEstimatedTimelineById(EstimatedTimelineId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "contactMaster/estimatedtimeline/delete/" + EstimatedTimelineId
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }


    /////// Processing AccountIssueType ///////


    public getProcessingAccountIssueTypeDetail() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "processing/accountissuetype/details"
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getProcessingAccountIssueTypeById(id: string) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "processing/accountissuetype/delete/" + id;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdateProcessingAccountIssueType(addAccountIssueType: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "processing/accountissuetype/addupdate"
        return this._httpHelper.post(environment.APIBaseUrl + url, addAccountIssueType, reqOption);
    }
    public deleteProcessingAccountIssueTypeById(AccountIssueTypeId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "processing/accountissuetype/delete/" + AccountIssueTypeId
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }

    /////// Processing AccountStatus ///////


    public getProcessingAccountStatusDetail() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "processing/accountstatus/details"
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getProcessingAccountStatusById(id: string) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "processing/accountstatus/details/" + id;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdateProcessingAccountStatus(addAccountStatus: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "processing/accountstatus/addupdate"
        return this._httpHelper.post(environment.APIBaseUrl + url, addAccountStatus, reqOption);
    }
    public deleteProcessingAccountStatusById(AccountStatusId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "processing/accountstatus/delete/" + AccountStatusId
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }


    /////// Roadmap FlagMaster ///////



    public getRoadmapFlagMasterDetail() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "roadmap/flagmaster/details"
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getRoadmapFlagMasterById(id: string) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "roadmap/flagmaster/details/" + id;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdateRoadmapFlagMaster(addFlagMaster: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "roadmap/flagmaster/addupdate"
        return this._httpHelper.post(environment.APIBaseUrl + url, addFlagMaster, reqOption);
    }
    public deleteRoadmapFlagMasterById(FlagMasterId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "roadmap/flagmaster/delete/" + FlagMasterId
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }


    /////// PreArrange Roadmap///////
    public getPreArrangeRoadmapDetail() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "roadmap/prearrangeroadmap/details"
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getPreArrangeRoadmapById(id: string) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "roadmap/prearrangeroadmap/details/" + id;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdatePreArrangeRoadmap(preArrangedRoadmapTemplateDc: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "roadmap/prearrangeroadmap/addupdate"
        return this._httpHelper.post(environment.APIBaseUrl + url, preArrangedRoadmapTemplateDc, reqOption);
    }
    public deletePreArrangeRoadmapById(prearrangeroadmapid: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "roadmap/prearrangeroadmap/delete/" + prearrangeroadmapid;
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }

    public getRoadmapTemplateByRoadmapId(roadmapId: string) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "roadmap/prearrangeroadmaptemplate/details/" + roadmapId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }





    ///// Tasks TaskCategory /////


    public getTasksTaskCategoryDetail() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "task/taskcategory/details"
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getTasksTaskCategoryById(id: string) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "task/taskcategory/details/" + id;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdateTasksTaskCategory(addTaskCategory: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "task/taskcategory/addupdate"
        return this._httpHelper.post(environment.APIBaseUrl + url, addTaskCategory, reqOption);
    }
    public deleteTasksTaskCategoryById(TaskCategoryId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "task/taskcategory/delete/" + TaskCategoryId
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }


    ////// Tasks TaskMaster //////


    public getTasksTaskMasterDetail() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "task/taskmaster/details"
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getTasksTaskMasterById(id: string) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "task/taskmaster/details/" + id;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }
    public getTasksMasterListByTaskCategoryId(taskcategoryid: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "task/taskmaster/detailsbycategoryid/" + taskcategoryid;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }
    public addUpdateTasksTaskMaster(addTaskMaster: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "task/taskmaster/addupdate"
        return this._httpHelper.post(environment.APIBaseUrl + url, addTaskMaster, reqOption);
    }
    public deleteTasksTaskMasterById(TaskMasterId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "task/taskmaster/delete/" + TaskMasterId
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }


    /////// Tasks TaskStatus ///////

    public getTasksTaskStatusDetail() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "task/taskstatus/details"
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getTasksTaskStatusById(id: string) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "task/taskstatus/details/" + id;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdateTasksTaskStatus(addTaskStatus: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "task/taskstatus/addupdate"
        return this._httpHelper.post(environment.APIBaseUrl + url, addTaskStatus, reqOption);
    }
    public deleteTasksTaskStatusById(TaskStatusId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "task/taskstatus/delete/" + TaskStatusId
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }


    //// Processing CreditMonitoring ////


    public getProcessingCreditMonitoringDetail() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "processing/creditmonitoring/details"
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getLangaugeMasterList() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contactMaster/Language/detail";
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getProcessingCreditMonitoringById(id: string) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "processing/creditmonitoring/details/" + id;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdateProcessingCreditMonitoring(addCreditMonitoring: any) {
        let file: FormData = addCreditMonitoring.Logo
        addCreditMonitoring.Logo = "";
        let headers: Headers = new Headers();
        headers.append('RequestModel', JSON.stringify(addCreditMonitoring));
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "processing/creditmonitoring/addupdate"
        return this._httpHelper.postFile(environment.APIBaseUrl + url, file, reqOption);
    }

    public deleteProcessingCreditMonitoringById(CreditMonitoringId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "processing/creditmonitoring/delete/" + CreditMonitoringId
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }


    //// Processing CreditBureaus ////

    public getProcessingCreditBureausDetail() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "processing/creditbureaus/details"
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getProcessingCreditBureausById(id: string) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "processing/creditbureaus/details/" + id;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdateProcessingCreditBureaus(addCreditBureaus: any) {
        let file: FormData = addCreditBureaus.CreditBureausLogo;
        addCreditBureaus.CreditBureausLogo = "";
        let headers: Headers = new Headers();
        headers.append('RequestModel', JSON.stringify(addCreditBureaus));
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "processing/creditbureaus/addupdate"
        return this._httpHelper.postFile(environment.APIBaseUrl + url, file, reqOption);

    }
    public deleteProcessingCreditBureausById(CreditBureausId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "processing/creditBureaus/delete/" + CreditBureausId
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }

    //////////////////// To-Do's ////////////////////////////

    public getAllToDoListDetails() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "roadmap/todomaster/details"
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getToDoDetailsById(todoid: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "roadmap/todomaster/details/" + todoid;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdateToDoDetails(addToDoDetails: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "roadmap/todomaster/addupdate"
        return this._httpHelper.post(environment.APIBaseUrl + url, addToDoDetails, reqOption);
    }
    public deleteToDoDetailsById(todoid: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "roadmap/todomaster/delete/" + todoid
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }

    //////////////////// Steps ////////////////////////////

    public getAllStepsListDetails() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "roadmap/stepmaster/details"
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getStepDetailsById(StepId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "roadmap/stepmaster/details/" + StepId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdateStepsDetails(addStepsDetails: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "roadmap/stepmaster/addupdate"
        return this._httpHelper.post(environment.APIBaseUrl + url, addStepsDetails, reqOption);
    }
    public deleteStepsDetailsById(StepId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "roadmap/stepmaster/delete/" + StepId
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdateFlagListByStepId(StepId: Number, FlagIdList: String) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "roadmap/stepmaster/addupdateflagonstep?stepid=" + StepId + "&flaglist=" + FlagIdList;
        return this._httpHelper.post(environment.APIBaseUrl + url, null, reqOption);
    }


    ///////// Affiliate /////////

    public getJobTitleListDetails() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "affiliate/jobtitle/details"
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getJobtitleById(JobId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "affiliate/jobttitle/details/" + JobId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdateJobTitleDetails(addJobDetails: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "affiliate/jobttitle/addupdate"
        return this._httpHelper.post(environment.APIBaseUrl + url, addJobDetails, reqOption);
    }
    public deleteJobTitleDetailsById(JobId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "affiliate/jobttitle/delete/" + JobId
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }
    //////////////////////////////////////////////////////
    public getIndustryListDetails() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "affiliate/industry/details"
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getIndustryById(IndustryId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "affiliate/industry/details/" + IndustryId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdateIndustryDetails(addIndustryDetails: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "affiliate/industry/addupdate"
        return this._httpHelper.post(environment.APIBaseUrl + url, addIndustryDetails, reqOption);
    }
    public deleteIndustryDetailsById(IndustryId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "affiliate/industry/delete/" + IndustryId
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }
    /////////////////////////////////////////////////////////


    public getReimbursementDetails() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "affiliate/reimbursement/details"
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getReimbursementById(ReimbursementId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "affiliate/reimbursement/details/" + ReimbursementId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdateReimbursementDetails(addReimbursementDetails: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "affiliate/reimbursement/addupdate"
        return this._httpHelper.post(environment.APIBaseUrl + url, addReimbursementDetails, reqOption);
    }
    public deleteReimbursementDetailsById(ReimbursementId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "affiliate/reimbursement/delete/" + ReimbursementId
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }


    ///////////////////// PROCESSING ////////////////////

    public getActionPlanDetails() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "processing/actionplan/details"
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getActionPlanById(PlanId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "processing/actionplan/details/" + PlanId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdateActionPlanDetails(addActionDetails: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "processing/actionplan/addupdate"
        return this._httpHelper.post(environment.APIBaseUrl + url, addActionDetails, reqOption);
    }
    public deleteActionPlanDetailsById(PlanId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "processing/actionplan/delete/" + PlanId
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }

    ///////////////////////////////////////////////////////////

    public getAccountTypeDetails() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "processing/accounttype/details"
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getAccountTypeById(AccountId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "processing/accounttype/details/" + AccountId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdateAccountTypeDetails(addAccountTypeDetails: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "processing/accounttype/addupdate"
        return this._httpHelper.post(environment.APIBaseUrl + url, addAccountTypeDetails, reqOption);
    }
    public deleteAccountTypeDetailsById(AccountId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "processing/accounttype/delete/" + AccountId
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }

    //////////////////////////////////////////////////////////////////


    public getCreditorTypeDetails() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "processing/creditortype/details"
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getCreditorTypeById(CreditorTypeId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "processing/creditortype/details/" + CreditorTypeId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdateCreditorTypeDetails(addCreditorTypeDetails: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "processing/creditortype/addupdate"
        return this._httpHelper.post(environment.APIBaseUrl + url, addCreditorTypeDetails, reqOption);
    }
    public deleteCreditorTypeDetailsById(CreditorTypeId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "processing/creditortype/delete/" + CreditorTypeId
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }

    //////////////////////////////////////////////////////////////


    public getRecommendationDetails() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "processing/recommendations/details"
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getRecommendationById(RecommendationId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "processing/recommendations/details/" + RecommendationId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdateRecommendationDetails(addRecommendationDetails: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "processing/recommendations/addupdate"
        return this._httpHelper.post(environment.APIBaseUrl + url, addRecommendationDetails, reqOption);
    }
    public deleteRecommendationDetailsById(RecommendationId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "processing/recommendations/delete/" + RecommendationId
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }

    ////Contacts Billing Package/////


    public getContactsBillingPackageDetail(employeeId = 0) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "billing/billingpackage/details";
        if (employeeId != 0) {
            url = "billing/billingpackage/getpackagesbyuserid/" + employeeId;
        }
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getContactsBillingPackageById(packageId: string, stateId = 0) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        stateId = stateId ? stateId : 0;
        let url = `billing/billingpackage/details/${packageId}?stateId=${stateId}`;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdateContactsBillingPackage(addBillingPackage: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "billing/billingpackage/addupdate"
        return this._httpHelper.post(environment.APIBaseUrl + url, addBillingPackage, reqOption);
    }
    public deleteContactsBillingPackageById(packageid: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "billing/billingpackage/delete/" + packageid
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }
    
    ////Checklist Master /////
    public getChecklistMasters() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "task/checklistmaster/details"
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getChecklistMasterById(checklistmasterid: string) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "task/checklistmaster/details/" + checklistmasterid;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdateChecklistMaster(addChecklistMaster: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "task/checklistmaster/addupdate"
        return this._httpHelper.post(environment.APIBaseUrl + url, addChecklistMaster, reqOption);
    }
    public deleteChecklistMasterById(checklistmasterid: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "task/checklistmaster/delete/" + checklistmasterid
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }

    ////Checklist Master Details/////


    public getChecklistMasterDetailList(checklistmasterid: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "task/checklistmasterdetails/details/" + checklistmasterid;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdateChecklistMasterDetails(addChecklistMasterDetails: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "task/checklistmasterdetails/addupdate";
        return this._httpHelper.post(environment.APIBaseUrl + url, addChecklistMasterDetails, reqOption);
    }
    public deleteChecklistMasterDetailsById(checklistdetailid: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "task/checklistmasterdetails/delete/" + checklistdetailid;
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }


    //////////////////////////////// Communication Master ///////////////////////////////////////////

    public getAllCommunicationList() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contactMaster/communication/details"
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public bindCommunicationList() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contactMaster/communication/bindcommunication"
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }


    public getCommunicationDetailsById(communicationid: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contactMaster/communication/detailsbyid/" + communicationid;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public DeleteCommunicationDetailsById(communicationid: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "contactMaster/communication/delete/" + communicationid
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }

    public AddUpdateCommunicationDetails(addCommunication: any) {
        let file: FormData = addCommunication.Image;
        addCommunication.Image = "";
        let headers: Headers = new Headers();
        headers.append('RequestModel', JSON.stringify(addCommunication));
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "contactMaster/communication/addupdate"
        return this._httpHelper.postFile(environment.APIBaseUrl + url, file, reqOption);
    }

    ////////////////////////////////Messages Master //////////////////////////////////////////////

    public addUpdateMessages(addMessages: any) {
        let file: FormData = addMessages.myFromData;
        addMessages.myFromData = "";
        let headers: Headers = new Headers();
        headers.append('RequestModel', JSON.stringify(addMessages));
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "contactMaster/messagesmaster/addupdate"
        return this._httpHelper.postFile(environment.APIBaseUrl + url, file, reqOption);
    }

    public getAllMessagesList() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contactMaster/messagesmaster/alldetails"
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public DeleteMessagesById(messageid: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "contactMaster/messagesmaster/delete/" + messageid
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }

    public getMessagesMasterDetailsById(messageid: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contactMaster/messagesmaster/details/" + messageid;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }


    ////Contacts Billing Description/////

    public getBillingDescriptionDetail(employeeId = 0, packageId = 0) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "billing/description/details";
        packageId = packageId ? packageId : 0;
        if (employeeId != 0) {
            url = `billing/description/bypackageId?packageId=${packageId}&employeeId=${employeeId}`;
        }
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }



    public getBillingDescriptionById(billingdescriptionid: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "billing/description/details/" + billingdescriptionid;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdateBillingDescription(addBillingDescription: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "billing/description/addupdate"
        return this._httpHelper.post(environment.APIBaseUrl + url, addBillingDescription, reqOption);
    }
    public deleteBillingDescriptionById(billingdescriptionid: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "billing/description/delete/" + billingdescriptionid
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }

    ////Contacts Billing Description/////

    public getMerchantMasterDetail() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "billing/merchant/details"
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public bindMerchantMasterDetail(userId, userType) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "billing/merchant/binddropdownlist?UserId=" + userId + "&UserType=" + userType;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getMerchantMasterById(merchantmasterid: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "billing/merchant/detailsbyid/" + merchantmasterid;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdateMerchantMaster(addMerchantMaster: any) {
        let file: FormData = addMerchantMaster.Logo;
        addMerchantMaster.Logo = "";
        let headers: Headers = new Headers();
        headers.append('RequestModel', JSON.stringify(addMerchantMaster));
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "billing/merchant/addupdate"
        return this._httpHelper.postFile(environment.APIBaseUrl + url, file, reqOption);

        // let headers: Headers = new Headers();
        // let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        // let url = "billing/merchant/addupdate"
        // return this._httpHelper.post(environment.APIBaseUrl + url, addMerchantMaster, reqOption);
    }
    public deleteMerchantMasterById(merchantmasterid: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "billing/merchant/delete/" + merchantmasterid
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }


    /////// Processing roadmap ///////

    public getRoadmapMasterDetail() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "roadmap/roadmapmaster/details"
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getRoadmapMasterById(id: string) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "roadmap/roadmapmaster/delete/" + id;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdateRoadmapMaster(addAccountIssueType: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "roadmap/roadmapmaster/addupdate";
        return this._httpHelper.post(environment.APIBaseUrl + url, addAccountIssueType, reqOption);
    }
    public deleteRoadmapMasterById(AccountIssueTypeId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "roadmap/roadmapmaster/delete/" + AccountIssueTypeId;
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }

    //payout
    public addPayout(payoutObj: IPayout) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "payoutmaster/addupdate";
        return this._httpHelper.post(environment.APIBaseUrl + url, payoutObj, reqOption);
    }

    public getPayoutList(): Observable<IPayout[]> {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "payoutmaster/details";
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public deletePayoutData(payoutId: number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "payoutmaster/delete/" + payoutId;
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }

    public addPlan(planObj: IPlan) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "planmaster/addupdate";
        return this._httpHelper.post(environment.APIBaseUrl + url, planObj, reqOption);
    }

    public getPlanList(): Observable<IPlan[]> {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "planmaster/details";
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public deletePlanData(planId: number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "planmaster/delete/" + planId;
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }


    public addGoal(goalObj: IAltGoals) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "altgoalmaster/addupdate";
        return this._httpHelper.post(environment.APIBaseUrl + url, goalObj, reqOption);
    }

    public getGoalList(): Observable<IAltGoals[]> {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "altgoalmaster/details";
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public deleteGoalData(GoalId: number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "altgoalmaster/delete/" + GoalId;
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }

    public activeDeactiveGoal(data: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "altgoalmaster/setactivedeactive";
        return this._httpHelper.put(environment.APIBaseUrl + url, data, reqOption);
    }

    public addProgress(ProgressObj) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "progress/addprogress";
        return this._httpHelper.post(environment.APIBaseUrl + url, ProgressObj, reqOption);
    }

    public editProgress(EditProgressObj) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Put, headers: headers });
        let url = "progress/editprogress";
        return this._httpHelper.put(environment.APIBaseUrl + url, EditProgressObj, reqOption);
    }

    public getProgressList() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "progress/getallprogress";
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public deleteProgressData(ProgressId: number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "progress/deleteprogress/" + ProgressId;
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }

    public addInfo(infoObj: IImpInfo) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "importantinfomaster/addupdate";
        return this._httpHelper.post(environment.APIBaseUrl + url, infoObj, reqOption);
    }

    public getInfoList(): Observable<IImpInfo[]> {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "importantinfomaster/details";
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public deleteInfoData(InfoId: number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "importantinfomaster/delete/" + InfoId;
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }

    // Add Industry Image
    public addIndustryImage(industryData: any, formData: FormData) {
        let file: FormData = formData;
        let headers: Headers = new Headers();
        headers.append('RequestModel', JSON.stringify(industryData));
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Put, headers: headers });
        let url = "affiliate/industry/uploadteamimage"
        return this._httpHelper.putFile(environment.APIBaseUrl + url, file, reqOption);
    }

    public addIndustryLogo(industryData: any, formData: FormData) {
        let file: FormData = formData;
        let headers: Headers = new Headers();
        headers.append('RequestModel', JSON.stringify(industryData));
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Put, headers: headers });
        let url = "affiliate/industry/uploadlogoimage"
        return this._httpHelper.putFile(environment.APIBaseUrl + url, file, reqOption);
    }

    public allowToFetchCreditReportOrNot(contactId) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "customerportal/allowtofetchcreditreportornot/" + contactId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    // Join The Credit Up Club
    public joinCreditUpClub(joinClubObj) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "creditupclub/joincreditclub";
        return this._httpHelper.post(environment.APIBaseUrl + url, joinClubObj, reqOption);
    }

    public getApprovalTypes() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "approvaltype/details";
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdateApprovalType(approvalType: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "approvaltype/addupdate";
        return this._httpHelper.post(environment.APIBaseUrl + url, approvalType, reqOption);
    }

    public deleteApprovalType(approvalTypeId: number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "approvaltype/delete/" + approvalTypeId;
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }

    public getDownPaymentTypes() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "downpaymenttype/details";
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdateDownPaymentType(downPaymentType: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "downpaymenttype/addupdate";
        return this._httpHelper.post(environment.APIBaseUrl + url, downPaymentType, reqOption);
    }

    public deleteDownPaymentType(downPaymentTypeId: number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "downpaymenttype/delete/" + downPaymentTypeId;
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }

    public getCustomerTimelineTypes() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "customertimelinetype/details";
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdateCustomerTimelineType(customerTimelineType: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "customertimelinetype/addupdate";
        return this._httpHelper.post(environment.APIBaseUrl + url, customerTimelineType, reqOption);
    }

    public deleteCustomerTimelineType(customerTimelineTypeId: number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "customertimelinetype/delete/" + customerTimelineTypeId;
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }

    public getAllLeadScores() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "leadscoremaster/details";
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }


    public getLeadScoreDetail(leadScoreId: number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = `leadscoremaster/details/${leadScoreId}`;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdateLeadScore(leadScore: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "leadscoremaster/addupdate";
        return this._httpHelper.post(environment.APIBaseUrl + url, leadScore, reqOption);
    }

    public deleteLeadScore(leadScoreId: number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = `leadscoremaster/delete/${leadScoreId}`;
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }

    public getAccountResults() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "processing/accountresulttype/details";
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdateAccountResult(accountResult: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "processing/accountresulttype/addupdate";
        return this._httpHelper.post(environment.APIBaseUrl + url, accountResult, reqOption);
    }

    public markUnmarkForAllLetter(data: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "processing/accountresulttype/markunmarkisforallLetter";
        return this._httpHelper.put(environment.APIBaseUrl + url, data, reqOption);
    }

    public deleteAccountResult(accountResultId: number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = `processing/accountresulttype/delete/${accountResultId}`;
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }

    public getSIDList(programId = 0) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = programId == 0 ? `sid/details` : `sid/getbyprogramid/${programId}`;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getSIDByEmployeeId() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = `sid/getbyemployeeid?employeeId=${SessionHelper.getUserId()}`;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdateSID(SIDDc: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = `sid/addupdate`;
        return this._httpHelper.post(environment.APIBaseUrl + url, SIDDc, reqOption);
    }

    public getSIDDetail(id: number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = `sid/details/${id}`;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public deleteSID(id: number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = `sid/delete/${id}`;
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }

    public getTrainingList() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = `training/details`;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdateTraining(TrainingDc: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = `training/addupdate`;
        return this._httpHelper.post(environment.APIBaseUrl + url, TrainingDc, reqOption);
    }

    public getTrainingDetail(id: number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = `training/details/${id}`;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public deleteTraining(id: number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = `training/delete/${id}`;
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }

    public getWelcomeLettersByFolderId(id: number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = `strategy/disputeLetter/detailsbyfolder/${id}`
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getMerchantsByEmployeeId(employeeId = 0) {
        const userId = SessionHelper.getUserId();
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = `billing/merchant/getbyemployeeid/${userId}`;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getContactMerchant(contactId: number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = `customerbilling/billingdetails/detailsbyid/${contactId}`;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addIntegration(integrationData: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "integration/config/add";
        return this._httpHelper.post(environment.APIBaseUrl + url, integrationData, reqOption);
    }

    public updateIntegration(integrationData: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "integration/config/update";
        return this._httpHelper.put(environment.APIBaseUrl + url, integrationData, reqOption);
    }

    public getIntegrationList() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "integration/config/details";
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getIntegrationDetailById(integrationId: number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = `integration/config/details/${integrationId}`;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }
}   



// WEBPACK FOOTER //
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/crm/services/configuration.service.ts